import {  PureComponent } from 'react'
import { Stepper, GetInfo } from '@operations/shared';
import RequestInfo from './requestInfo';

class ViewRequestInfo extends PureComponent{
    

    render() {
        const components = [
            {
                title: 'Get Request',
                content: <GetInfo apiLink='requests/getAdvancesIssues' request={true}/>,
                id: 0,
            }, {
                title: 'Request Info',
                content: <RequestInfo />,
                id: 1
            },
        ]
        return (
            <>
                <Stepper componentSteps={components} request={true}/>
            </>
        )
    }
}

export default ViewRequestInfo